<template>
  <div class="ncc-book__create new_creak">
    <div class="area">
      <div class="card">
        <h3>打造皇家兵器</h3>
        <el-form :model="formParams" :rules="rules" label-position="top" ref="ruleForm">
          <div class="form-item">
            <el-form-item label="兵器名称" prop="title">
              <el-input v-model="formParams.title" placeholder="请输入标题名称"></el-input>
            </el-form-item>
          </div>
          <div class="form-item">
            <el-form-item label="分组" prop="viewScope">
              <el-radio-group v-model="formParams.viewScope">
                <el-radio :label="1" border>全员可见</el-radio>
                <el-radio :label="3" border>队长可见</el-radio>
                <el-radio :label="2" border>队长/副队长</el-radio>
              </el-radio-group>
            </el-form-item>
          </div>
          <div class="form-item">
            <el-form-item label="属性" prop="shuxingId">
              <el-radio-group v-model="formParams.shuxingId">
                <el-radio :label="i.shuxingId" v-for="(i, k) in shuxingList" :key="k" border>{{ i.shuxingName }}
                </el-radio>
              </el-radio-group>
            </el-form-item>
          </div>
          <div class="form-item new-form-item have-radio">
            <el-form-item label="分类" prop="toolkitId">
              <el-radio-group v-model="formParams.toolkitId">
                <el-radio :label="i.toolkitId" v-for="(i, k) in toolkitList" :key="k" border
                  @change="chooseProductId(i)">{{ i.toolkitName }}</el-radio>
              </el-radio-group>
            </el-form-item>
          </div>
          <div class="form-item">
            <el-form-item label="所属品牌" prop="customerId">
              <el-select v-model="formParams.customerId" placeholder="请选择所该兵器所属的品牌，以便在创建该品牌项目任务时可以直接跳转查看该兵器"
                @change="handleCollgeChange" filterable>
                <el-option v-for="(i, k) in brandList" :label="i.customerName" :value="Number(i.id)" :key="k">
                </el-option>
              </el-select>
            </el-form-item>
          </div>
          <div class="label"><span>*</span>兵器目录</div>
          <div class="operate">
            <div class="summary new-summary">
              <vue-ueditor-wrap ref="muluEditor" v-model="formParams.mulu" class="editor" :config="myconfig">
              </vue-ueditor-wrap>
            </div>
          </div>
          <div class="form-item">
            <el-form-item label="兵器打造日期" prop="pubTime">
              <el-date-picker v-model="formParams.pubTime" type="date" placeholder="请选择兵器打造日期">
              </el-date-picker>
            </el-form-item>
          </div>

          <div class="label"><span>*</span>兵器打造的目的及概述</div>
          <div class="operate">
            <div class="summary new-summary">
              <vue-ueditor-wrap ref="summay" v-model="formParams.summay" class="editor" :config="myconfigTwo">
              </vue-ueditor-wrap>
            </div>
          </div>
          <div class="form-item">
            <el-form-item label="兵器适用范围" prop="useRange">
              <el-input v-model="formParams.useRange" placeholder="请输入该兵器的适用范围" type="textarea" autosize></el-input>
            </el-form-item>
          </div>
          <div class="label"><span>*</span> 流程图 （<span
              class="info-msg">注：</span>流程图中应包含节点负责人、节点工具、节点标准、节点风险；仅支持jpg、png格式上传，大小不超过2m）</div>
          <div class="operate upload-img">
            <el-upload class="avatar-uploader" action="/api/ueditor/index?action=uploadfile&encode=utf-8"
              :show-file-list="false" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
              <img v-if="imageUrl" :src="imageUrl" class="avatar">
              <img v-else src="../../assets/images/nccBook/process-pic.png" alt="" width="566px" />
            </el-upload>
          </div>
          <div class="comments-gray have-add-button">
            <div>
              <span> <span class="info-msg">*</span>流程节点工作标准 </span>
            </div>
          </div>
          <!-- <el-form-item prop="contentNode" class="flex-form-item new-comments"> -->
          <div class="form-file new-form-file new-form-file-one" v-for="(i, k) in formParams.contentNode" :key="k">
            <div class="comments-gray-btn all-btn" @click="addItems('processNode')">
              <el-button icon="el-icon-error" type="text" class="red-important" @click="removeFile(k)"
                v-if="formParams.contentNode.length > 1">删除文件</el-button>
              <el-button icon="el-icon-circle-plus" type="text" @click="addFile"
                v-if="formParams.contentNode.length === k + 1">继续添加文件</el-button>
            </div>
            <div class="operate">
              <div class="summary">
                <vue-ueditor-wrap :ref="`storeEditor${k}`" v-model="formParams.contentNode[k]" class="editor"
                  :config="editOptList[k].editOpt"></vue-ueditor-wrap>
                <!-- 用于将图片base64转url -->
                <el-upload :show-file-list="false" :on-success="
                    (res) => {
                      handleEditSuccess(res, k);
                    }
                  " :max-size="2048" multiple action="/api/ueditor/index?action=uploadfile&encode=utf-8">
                  <el-button :class="{ [`quillUpload${k}`]: true }" icon="el-icon-upload2" type="text"></el-button>
                </el-upload>
              </div>
            </div>
          </div>
          <!-- </el-form-item> -->
          <div class="form-item">
            <el-form-item label="数字化建议" prop="suggest">
              <el-input v-model="formParams.suggest" placeholder="请输入数字化建议" type="textarea" autosize></el-input>
            </el-form-item>
          </div>
          <div class="comments-gray have-add-button">
            <div>
              <span> <span class="info-msg">*</span>专业术语 </span>
            </div>
            <div class="comments-gray-btn" @click="addItems('professional')">
              <Icon type="plus-circled" size="16"></Icon>
              继续添加
            </div>
          </div>
          <el-form-item prop="tipWord" class="flex-form-item">
            <div v-for="(item, index) in formParams.tipWord" :key="index" class="item-flex item-flex--add">
              <el-input v-model="item.title" class="resizeNone input-bottom" autosize placeholder="专业术语名称">
              </el-input>
              <el-input v-model="item.summay" class="resizeNone-long input-bottom" autosize placeholder="专业术语名称及解释">
              </el-input>
              <el-button v-if="
                  formParams.tipWord.length > 1 &&
                  formParams.tipWord.length === index + 1
                " type="text" class="have-add-button" @click="removeItems('professional', index)">
                <slot><img class="add-img" src="@/assets/images/dri/close_red@2x.png" /></slot>
              </el-button>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <div class="btn-group">

        <div class="custom-btn custom-btn--default" 
          v-if="!isEditMode || formParams.btnSave_visible === 'show'">
          <el-button :loading="saveBtn" type="defaultDiy" @click="judgeForm(1)">
            保存
          </el-button>
        </div>
        <div class="custom-btn custom-btn--primary" 
          v-if="!isEditMode || formParams.btnApply_visible === 'show'">
          <el-button :loading="submitBtn" type="primaryDiy" @click="judgeForm(2)">
            提交审核
          </el-button>
        </div>

      </div>

    </div>

  </div>
</template>

<script type="text/jsx">
  import "./Index.less";
import { NccBook } from "@/API/api";
import { editorOptions } from "../../util/util";
import { Message, MessageBox } from "element-ui";
// import merge from "deepmerge";
import VueUeditorWrap from "vue-ueditor-wrap";
import VueCropper from "vue-cropper";
const editOptItem = (k) => {
  return {
    editOpt: {
      // 编辑器不自动被内容撑高
      autoHeightEnabled: false,
      // 初始容器高度
      initialFrameHeight: 240,
      // 初始容器宽度
      initialFrameWidth: "100%",
      serverUrl: "/api/ueditor/index?action=config&encode=utf-8",
      UEDITOR_HOME_URL:
       process.env.VUE_APP_TITLE == "development" ? "/UE/" : "/static/UE/" ,
         initialContent:'请填写每个流程对应的工作内容标准：含节点负责人、节点工具、节点标准、节点风险及注意事项，如节点工具涉及文件模版及制作规范请上传附件',
      autoClearinitialContent:true,
    },
  };
};

export default {
  name: "StoreCreate",
  components: { VueUeditorWrap, VueCropper },
  data() {
    return {
      submitBtn:false,
      saveBtn:false,
        imageUrl: '',
      avatar: "",
      previewImg: "",
      isUploadAvatar: false,
      showMsg: false,
      isEditMode: false,
      shuxingList: [],
      upLoad: require("../../assets/images/dri/upload.png"),
      myconfig: {
        autoHeightEnabled: false,
        // 初始容器高度
        initialFrameHeight: 240,
        // 初始容器宽度
        initialFrameWidth: "100%",
        serverUrl: "/api/ueditor/index?action=config&encode=utf-8",
        UEDITOR_HOME_URL:
         process.env.VUE_APP_TITLE == "development" ? "/UE/" : "/static/UE/" ,
        autoFloating: "false",
      initialContent:'请在此填写该兵器目录',
      autoClearinitialContent:true,
      },
         myconfigTwo: {
        autoHeightEnabled: false,
        // 初始容器高度
        initialFrameHeight: 240,
        // 初始容器宽度
        initialFrameWidth: "100%",
        serverUrl: "/api/ueditor/index?action=config&encode=utf-8",
        UEDITOR_HOME_URL:
         process.env.VUE_APP_TITLE == "development" ? "/UE/" : "/static/UE/" ,
        autoFloating: "false",
      initialContent:'请在此填写该兵器打造的目的及概述',
      autoClearinitialContent:true,
      },
      formParams: {
        // collegeId: null,
        // studyId: null,
        viewScope: 1,
        shuxingId: 1,
        title: "",
        opType: null,
        customerId: null,
        // typeId: 1,
        productId: 1,
        toolkitId: null,
        mulu: "",
        fileContent: [
          {
            fileName: "",
            filePath: "",
            summary: "",
            fileSize: "",
          },
        ],
        tipWord: [
          {
            title: "",
            summay: "",
          },
        ],
        pubTime: "",
        summay: "",
        useRange: "",
        contentNode: [""],
        suggest: "",
      },
      rules: {
        title: [{ required: true, message: "请输入兵器库名称", trigger: "blur" },
        { max:200, message: '兵器库名称最长200个字符', trigger: 'change' }],
        // collegeId: [{ required: true, message: "请选择学院", trigger: "blur" }],
        toolkitId: [{ required: true, message: "请选择分类", trigger: "blur" }],
        // studyId: [{ required: true, message: "请选择专业", trigger: "blur" }],
        viewScope: [{ required: true, message: "请选择分组", trigger: "blur" }],
        shuxingId: [{ required: true, message: "请选择属性", trigger: "blur" }],
        productId: [
          { required: true, message: "请选择工具包", trigger: "blur" },
        ],
        tipWord: [
          {
            required: true,
            validator: (_, val, callback) => {
              if (
                this.formParams.tipWord[this.formParams.tipWord.length - 1]
                  .title === "" ||
                this.formParams.tipWord[this.formParams.tipWord.length - 1]
                  .summay === ""
              ) {
                callback("请完善专业术语");
              } else callback();
            },
            trigger: "blur",
          },
        ],
        pubTime: [
          { required: true, message: "请选择兵器打造日期", trigger: "blur" },
        ],
        summay: [
          {
            required: true,
            message: "请输入兵器打造的目的及概述",
            trigger: "blur",
          },
        ],
        useRange: [
          {
            required: true,
            message: "请输入该兵器的适用范围",
            trigger: "blur",
          },
        ],
        // picture: [{ required: true, message: "请上传流程图", trigger: "blur" }],
        contentNode: [
          {
            required: true,
            validator: (_, val, callback) => {
              if (
                this.formParams.contentNode[
                  this.formParams.contentNode.length - 1
                ] === ""
              ) {
                callback("请输入流程节点工作标准");
              } else callback();
            },
            trigger: "blur",
          },
        ],
      },
      toolkitList: [],
      collegeList: [],
      collegestudylist: [],
      /* 富文本配置项 */
      editOptList: [],
      brandList: [],
      typeList: [],
      toolkitbyproductList: [],
    };
  },
  computed: {
    storeId() {
      return this.$route.query.storeId;
    },
    userInfo() {
      return JSON.parse(localStorage.getItem("userInfo"));
    },
  },
  async created() {
    if (this.$route.query.storeId) this.isEditMode = true; // 进入编辑模式

    await Promise.all([
      // (async () => {
      //   const collegeRes = await this.getCollegeList();
      //   const defaultCollege = [
      //     {
      //       collegeId: "0",
      //       title: "全部",
      //       item: [],
      //     },
      //   ];
      //   this.collegeList = [...defaultCollege, ...collegeRes.data.retData.data];
      // })(),
      (async () => {
        const customer = await this.getBrand();
        this.brandList = customer.data.retData.customer_list.data;
      })(),
      (async () => {
        const type = await this.getType();
        //   const formattool = type.data.retData.typeList.map((e) => ({
        //   val: Number(e.id),
        //   label: e.title,
        // }));
        this.typeList = type.data.retData.typeList;
      })(),
      (async () => {
        const toolkitbyproductRes = await this.getToolkitbyproduct();
        this.toolkitbyproductList = toolkitbyproductRes.data.retData.toolkit;
        this.toolkitList = toolkitbyproductRes.data.retData.toolkitOneLevel;
      })(),

      (async () => {
        const storeDetailRes = await this.getStoreDetail();
        this.formParams = {
          ...this.formParams,
          ...storeDetailRes.data.retData.tipsInfo,
        };
        this.imageUrl=this.formParams.picture
        console.log(this.formParams, "this.formParams");
        if (this.formParams.contentNode.length == 0) {
          this.formParams.contentNode = [""];
        }
        if (this.formParams.tipWord.length == 0) {
          this.formParams.tipWord = [{ title: "", summay: "" }];
        }
        this.formParams.contentNode.map((i, k) => {
      
          this.editOptList.push(editOptItem(k));
        });
            console.log(this.editOptList[0].editOpt, "i");
        const storeshuxinglistRes = await this.getStoreshuxinglist();
        this.shuxingList = storeshuxinglistRes.data.retData.shuxingList;

        if (this.formParams.collegeId) {
          const collegestudylistRes = await this.getCollegeStudyList(
            this.formParams.collegeId
          );
          const defaultStudy = [
            {
              studyId: "0",
              title: "全部",
            },
          ];
          this.collegestudylist = [
            ...defaultStudy,
            ...collegestudylistRes.data.retData.data,
          ];
        } else if (this.formParams.collegeId === 0) {
          this.collegestudylist = [
            {
              studyId: "0",
              title: "全部",
            },
          ];
        }
      })(),
    ]);
  },
  methods: {
      handleAvatarSuccess(res, file) {
        console.log(file.response.url,'file')
        // this.imageUrl = URL.createObjectURL(file.raw);
        this.imageUrl = file.response.url;

        this.formParams.picture=this.imageUrl
        console.log( this.imageUrl,' this.imageUrl')
      },
      beforeAvatarUpload(file) {
        console.log(file.type,'file.type')
        const isJPG = file.type === 'image/jpeg'||file.type ==='image/png'||file.type ==='image/jpg';
        const isLt2M = file.size / 1024 / 1024 < 2;
        if (!isJPG) {
          this.$message.error('上传头像图片只能是 JPG或png 格式!');
        }
        if (!isLt2M) {
          this.$message.error('上传头像图片大小不能超过 2MB!');
        }
        return isJPG && isLt2M;
      },
    removeItems(key, index) {
      if (key == "professional") {
        this.formParams.tipWord.splice(index, 1);
      }
      this.$forceUpdate();
      this.$set(this.formParams);
    },
    addItems(key) {
      console.log("3333");
      //专业术语
      if (key == "professional") {
        if (
          this.formParams.tipWord[this.formParams.tipWord.length - 1].title ===
            "" ||
          this.formParams.tipWord[this.formParams.tipWord.length - 1]
            .summay === ""
        ) {
          console.log( this.formParams.tipWord[this.formParams.tipWord.length - 1].summary,'summary')
          console.log( this.formParams.tipWord[this.formParams.tipWord.length - 1].title,'title')
          this.$notify({
            title: "失败",
            message: "请先完成之前的操作",
            type: "error",
            duration: 2000,
          });
          return;
        } else {
          this.formParams.tipWord.push({
            title: "",
            summay: "",
          });
        }
      } else {
        if (
          this.formParams.contentNode[
            this.formParams.contentNode.length - 1
          ] === ""
        ) {
          this.$notify({
            title: "失败",
            message: "请先完成之前的操作",
            type: "error",
            duration: 2000,
          });
          return;
        } else {
          this.formParams.contentNode.push("");
        }
      }
      this.$forceUpdate();
      this.$set(this.formParams);
    },
    /* 上传封面头像 */
    async uploadAvatar() {
      this.isUploadAvatar = true;
      const avatar = {
        myPic: this.avatar,
      };
      const avatarRes = await (() => {
        return this.$http.post(NccBook.changepicup, this.qs.stringify(avatar), {
          headers: { Authorization: "Bearer " + this.$cookie.get("token") },
        });
      })();
      this.isUploadAvatar = false;
      const { retCode, retData } = avatarRes.data;
      if (retCode === 0) {
        this.cancelAvatar();
        this.formParams.picture = retData.url;
        console.log(retData.url,'retData.url')
      }
    },
    realTime(data) {
      this.$refs.cropper.getCropData((data) => {
        this.avatar = data;
      });
    },
    cancelAvatar() {
      this.previewImg = null;
      this.avatar = null;
    },
    checkOverSize(size) {
      let isOver = false;
      if (size / 1024 / 1024 > 2) {
        Message.warning({
          message: "图片不能大于2MB",
        });
        return true;
      }
      return isOver;
    },
    selectImg(e) {
      let file = e.target.files[0];
      if (this.checkOverSize(file.size)) {
        return;
      }
      let reader = new FileReader();
      reader.onload = (e) => {
        let data;
        if (typeof e.target.result === "object") {
          // 把Array Buffer转化为blob 如果是base64不需要
          data = window.URL.createObjectURL(new Blob([e.target.result]));
        } else {
          data = e.target.result;
        }
        this.previewImg = data;
      };
      // 转化为base64
      // reader.readAsDataURL(file)
      // 转化为blob
      reader.readAsArrayBuffer(file);
    },
    chooseProductId(val) {
      console.log(val, "val");
      this.formParams.productId = val.productId;
    },
    handleChange(value) {
      console.log(value);
    },
    handleBeforeUpload(file) {
      console.log(this.showMsg, "this.showMsg");
      console.log(file.size > 1024 * 1000 * 2, "file.size");
      if (file.size > 1024 * 1000 * 2) {
        MessageBox.confirm(
          `<div class="upload-error-wrapper">
        <span class="upload-fail-img"></span>
        <p class="error-msg">很抱歉，文件超过2MB</p>
        <p class="error-msg">您可以重新上传</p>
      </div>`,
          {
            dangerouslyUseHTMLString: true,
          }
        );

        return false;
      }
      // this.showMsg = true;
      return true;
    },
    // 获取品牌
    getBrand() {
      let params = {
        page: 1,
        pageSize: 1000,
      };
      return this.$http.post(NccBook.brandList, this.qs.stringify(params), {
        headers: { Authorization: "Bearer " + this.$cookie.get("token") },
      });
    },
    handleSuccess(file, k) {
      // this.formParams.fileContent[k].fileName = file.name;
      // this.formParams.fileContent[k].filePath = file.response;
      // this.formParams.fileContent[k].fileSize = file.size;
      console.log(file,'file')
         this.formParams.picture ='https://excalibur.gaiyadata.com'+ file.url;
       
      Message.success("上传成功");
        console.log(this.formParams.picture,'this.formParams.picture')
      // this.showMsg = false;
    },

    handleError() {
      Message.error("上传失败");
      this.showMsg = false;
    },
    clearFile(k) {
      this.formParams.fileContent[k].fileName = "";
      this.formParams.fileContent[k].filePath = "";
      this.formParams.fileContent[k].summary = "";
      this.formParams.fileContent[k].fileSize = "";
    },
    removeFile(k) {
      this.formParams.contentNode.splice(k, 1);
      // this.fileList.splice(k, 1);
      this.editOptList = []; // 每次删除文件都要清空配置列表
      this.formParams.contentNode.map((i, k) => {
        this.editOptList.push(editOptItem(k));
      });
    },
    addFile() {
      this.formParams.contentNode.push();
      this.editOptList.push(
        editOptItem(this.formParams.fileContent.length - 1)
      );
    },
    handleEditSuccess(res, k) {
      // 获取富文本组件实例
      const mapEditor = this.$refs[`storeEditor${k}`][0];
      const { quill } = mapEditor;

      this.$nextTick(() => {
        // 如果上传成功
        if (res) {
          // 获取光标所在位置
          const length = quill.getSelection().index;
          // 插入图片，res为服务器返回的图片链接地址
          quill.insertEmbed(length, "image", res);
          // 调整光标到最后
          quill.setSelection(length + 1);
        } else {
          // 提示信息，需引入Message
          Message.error("图片插入失败");
        }
      });
    },
    // 获得分类
    getType() {
      return this.$http.post(NccBook.storetypelist, this.qs.stringify(), {
        headers: { Authorization: "Bearer " + this.$cookie.get("token") },
      });
    },
    async handleCollgeChange(collegeId) {
      this.formParams.studyId = null;
      const defaultStudy = [
        {
          studyId: "0",
          title: "全部",
        },
      ];

      if (collegeId !== 0) {
        const collegestudylistRes = await this.getCollegeStudyList(collegeId);

        this.collegestudylist = [
          ...defaultStudy,
          ...collegestudylistRes.data.retData.data,
        ];
      } else {
        this.collegestudylist = defaultStudy;
      }
    },
    /* 属性列表 */
    getStoreshuxinglist() {
      return this.$http.post(NccBook.storeshuxinglist, this.qs.stringify(), {
        headers: { Authorization: "Bearer " + this.$cookie.get("token") },
      });
    },
    /* store详情 */
    getStoreDetail() {
      return this.$http.post(
        NccBook.storedetailfront,
        this.qs.stringify({ storeId: this.storeId }),
        {
          headers: { Authorization: "Bearer " + this.$cookie.get("token") },
        }
      );
    },
    /* 获取工具包列表 */
    getToolkitbyproduct() {
      return this.$http.post(
        NccBook.toolkitbyproductstore,
        this.qs.stringify(),
        {
          headers: { Authorization: "Bearer " + this.$cookie.get("token") },
        }
      );
    },
    /* 获取学院列表 */
    // getCollegeList() {
    //   return this.$http.post(NccBook.collegelist, this.qs.stringify(), {
    //     headers: { Authorization: "Bearer " + this.$cookie.get("token") },
    //   });
    // },
    /* 获取专业列表 */
    getCollegeStudyList(collegeId) {
      return this.$http.post(
        NccBook.collegestudylist,
        this.qs.stringify({ collegeId }),
        {
          headers: { Authorization: "Bearer " + this.$cookie.get("token") },
        }
      );
    },
    /* 表单校验 */
    judgeForm(opType) {
      let formVaild = true;
      this.$refs["ruleForm"].validate((vaild, obj) => {
        if (!vaild) {
          for (const prop in obj) {
            if (
              !this.formParams[prop] ||
              (Array.isArray(this.formParams[prop]) &&
                !this.formParams[prop].length)
            ) {
              Message.warning({
                message: obj[prop][0].message,
              });
              formVaild = false;
              break;
            }
          }
        }
      });
      /* 校验上传文件 */
      let vaild;
      console.log(this.formParams.picture,'this.formParams.picture')
      if (formVaild) {
        console.log(this.formParams.mulu,'this.formParams.mulu')
        if (this.formParams.mulu == ""||this.formParams.mulu == null) {
          Message.warning({
            message: "请输入兵器目录",
          });
          vaild = false;
        }else if(this.formParams.summay==""){
            vaild = false;
            Message.warning({
              message: "请输入兵器库打造的目的及概述",
            });
        }else if(this.formParams.picture==""||this.formParams.picture==undefined){
          
              vaild = false;
            Message.warning({
              message: "请上传流程图",
            });
        } else if (
          this.formParams.contentNode[this.formParams.contentNode.length - 1] ==
          ""
        ) {
          if (this.formParams.contentNode.length == 1) {
            vaild = false;
            Message.warning({
              message: "请输入流程节点工作标准",
            });
          } else {
            this.formParams.contentNode = this.formParams.contentNode.splice(
              0,
              this.formParams.contentNode.length - 1
            );
            vaild = true;
          }
        } else {
          vaild = true;
        }

        if (vaild == true) {
       
          this.saveStore(opType);
        }
      }
    },
    async saveStore(opType) {
      if(opType===1){
        this.saveBtn=true;
      }else{
        this.submitBtn=true;

      }
      let url = this.isEditMode ? NccBook.storeedit : NccBook.storeadd;
       this.formParams.opType =opType;
      if(this.formParams.storeId>0){
      url= NccBook.storeedit
      }
      const res = await this.$http.post(
        url,
        this.qs.stringify(this.formParams),
        {
          headers: { Authorization: "Bearer " + this.$cookie.get("token") },
        }
      );
      this.saveBtn=false;
       this.submitBtn=false;
      if (res.data.retCode === 0) {
        Message.success({
          message: "提交成功",
        });
        this.$router.push({ name: "nccBookStore" });
      } else {
        Message.success({
          message: res.data.retMsg,
        });
      }
    },
  },
  mounted() {
    console.log(editorOptions, "editorOptions");
  },
};
</script>

<style lang="less" scoped>
  .left {
    display: inline-flex;
    align-items: center;

    >div {
      flex: none;
      width: 566px !important;
      height: 280px !important;
      position: relative;

      input {
        position: absolute;
        left: 0;
        top: 0;
        opacity: 0;
      }

      .cover,
      input {
        width: 566px !important;
        height: 280px !important;
        cursor: pointer;
      }
    }

    >p {
      padding: 0 40px 0 20px;
      font-size: 14px;
      color: #666666;
      line-height: 20px;

      span {
        color: #e02020;
      }
    }
  }

  .operate {
    position: relative;
    z-index: 1;
    border: none !important;
  }

  .user {
    width: 20px;
    height: 20px;
    margin: 0 10px;
    border-radius: 50%;
    overflow: hidden;
    cursor: pointer;
    display: inline-block;

    img {
      width: 20px;
      height: 20px;
      object-fit: cover;
      vertical-align: middle;
    }

    div {
      width: 20px;
      height: 20px;
      background-color: #ccc;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      font-weight: bold;
      color: #fff;
    }
  }

  .new-summary {
    margin-bottom: 22px;
    position: relative;
    z-index: 1;
  }

  .new_creak {
    .new-form-item {

      // /deep/.el-form-item{
      //   margin-bottom: 12px;
      // }
      /deep/ .el-radio {
        margin-bottom: 10px !important;
      }
    }

    /deep/ .el-radio__inner {
      width: 0;
      height: 0;
      border: none;
      display: none;
    }

    /deep/ .el-radio.is-bordered {
      height: 28px;
      border-radius: 14px;
      line-height: 20px;
      padding: 4px 12px;
    }

    /deep/ .el-radio {
      margin-right: 10px;
      // margin-bottom: 5px;
    }

    .el-radio.is-bordered+.el-radio.is-bordered {
      margin-left: 0px;
    }

    /deep/.el-radio__label {
      padding-left: 0;
    }

    /deep/ .el-radio.is-bordered.is-checked .el-radio__label {
      color: #0091ff !important;
    }

    .el-radio-group {
      border: none !important;
      // border: 1px solid #dcdfe6;
      border-radius: 4px;
      width: 100%;
      // height: 40px;
      display: flex;
      align-items: center;
      padding-left: 0px !important;
      flex-wrap: wrap !important;

      .el-radio__label {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        // color: #343a40;
        line-height: 20px;
        flex: 1;
      }
    }
  }

  .avatar {
    max-width: 566px;

    display: block;
  }

  .summary {
    /deep/#initContent {
      color: gray !important;
    }
  }

  .el-button--default {
    padding: 0;
    border: none;
  }

</style>
<style scoped src="@/assets/less/buttonBase.less" lang="less">
